module.exports = __webpack_public_path__ + "u16.no2.ec8aa668.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u16.no2.jpg
// module id = uouD
// module chunks = 0